import KeyResultMeasurement from "@/constants/KeyResultMeasurement";
import numeral from "numeral";

const _calculatePercentCompleted = keyResult => {
	const { currentValue, goalValue, } = keyResult;
	const currentNumber = numeral( currentValue ).value();
	const goalNumber = numeral( goalValue ).value();
	return Math.floor( ( currentNumber / goalNumber ) * 100 );
};

const completionCalculations = {
	[ KeyResultMeasurement.BINARY ]: keyResult => {
		const { currentValue, goalValue, } = keyResult;
		return currentValue === goalValue ? 100 : 0;
	},
	[ KeyResultMeasurement.PERCENTAGE ]: _calculatePercentCompleted,
	[ KeyResultMeasurement.CURRENCY ]: _calculatePercentCompleted,
	[ KeyResultMeasurement.NUMERIC ]: _calculatePercentCompleted,
};

/**
 * Calculate the completion percentage of a given key result (based on type).
 * @param {Object} keyResult
 * @returns {Number}
 */
export const calculatePercentCompleted = keyResult => {
	const calculator = completionCalculations[ keyResult.type ] || ( () => 0 );
	return calculator( keyResult );
};



// WEBPACK FOOTER //
// ./src/lib/keyResultUtil.js